import { Link, usePage } from '@inertiajs/react'
import { useOrgPath } from '@/lib/pathFor'

interface Tab {
  name: string
  path: string
  matchPrefix: string
}

const TABS: Tab[] = [
  { name: 'General', path: '/settings', matchPrefix: '/settings' },
  { name: 'Pricing', path: '/settings/pricing', matchPrefix: '/settings/pricing' },
  { name: 'Automation', path: '/settings/automation', matchPrefix: '/settings/automation' },
  { name: 'Rate Sheets', path: '/settings/rate_sheets', matchPrefix: '/settings/rate_sheets' },
  { name: 'Team', path: '/settings/users', matchPrefix: '/settings/users' },
  { name: 'Carriers', path: '/settings/carriers', matchPrefix: '/settings/carriers' },
]

export default function SettingsLayout({ children }: { children: React.ReactNode }) {
  const { url } = usePage()
  const pathFor = useOrgPath()

  function isActive(matchPrefix: string) {
    const fullPrefix = pathFor(matchPrefix)
    if (matchPrefix === '/settings') {
      // General is exact match; Team and Carriers are nested prefixes
      return url === fullPrefix || (url.startsWith(`${fullPrefix}?`) ?? false)
    }
    return url.startsWith(fullPrefix)
  }

  return (
    <>
      <nav className="flex h-10 items-center gap-1 border-b bg-muted/30 px-8">
        {TABS.map((tab) => {
          const active = isActive(tab.matchPrefix)
          return (
            <Link
              key={tab.path}
              href={pathFor(tab.path)}
              className={`relative inline-flex h-10 items-center px-3 text-[13px] font-medium transition-colors cursor-pointer ${
                active
                  ? 'text-foreground after:absolute after:inset-x-0 after:bottom-0 after:h-0.5 after:bg-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              {tab.name}
            </Link>
          )
        })}
      </nav>
      <div className="flex flex-1 flex-col overflow-hidden">{children}</div>
    </>
  )
}
